import { Route, Switch, useRouteMatch } from "react-router-dom";

import { WorkBadgeReviewPolicyPage } from "../WorkBadges/components/Policy/WorkBadgeReviewPolicyPage";
import { IndependentContractorBadgePage } from "./components/IndependentContractorBadge/Page";
import { DocumentDetailsPageContainer } from "./Details/Container";
import { DocumentsPageContainer } from "./DocumentsPage/Container";
import { DocumentsPageAccordionProvider } from "./DocumentsPage/useAccordionProvider";
import { NCOrientationPage } from "./NorthCarolinaOrientation/Page";
import {
  DOCUMENT_DETAILS_PATH,
  DOCUMENT_SEARCH_PATH,
  INDEPENDENT_CONTRACTOR_BADGE_PATH,
  NC_ORIENTATION_PATH,
  WORK_BADGE_REVIEW_POLICY_PATH,
  WORKPLACE_DOCUMENTS_PATH,
} from "./paths";
import { DocumentSearchPage } from "./Search/Page";
import { FileUploaderProvider } from "./useFileUploaderContext";
import { WorkplaceDocumentsPage } from "./Workplace/Page";

export function DocumentsRouter() {
  const match = useRouteMatch();

  return (
    <DocumentsPageAccordionProvider>
      <Switch>
        <Route exact path={`${match.url}`}>
          <DocumentsPageContainer />
        </Route>
        <Route exact path={`${match.url}/${INDEPENDENT_CONTRACTOR_BADGE_PATH}`}>
          <IndependentContractorBadgePage />
        </Route>
        <Route exact path={`${match.url}/${WORK_BADGE_REVIEW_POLICY_PATH}`}>
          <WorkBadgeReviewPolicyPage />
        </Route>
        <Route exact path={`${match.url}/${NC_ORIENTATION_PATH}`}>
          <NCOrientationPage />
        </Route>
        <Route exact path={`${match.url}/${DOCUMENT_SEARCH_PATH}`}>
          <DocumentSearchPage />
        </Route>
        <Route path={`${match.url}/${WORKPLACE_DOCUMENTS_PATH}`}>
          <WorkplaceDocumentsPage />
        </Route>
        <Route path={`${match.url}/${DOCUMENT_DETAILS_PATH}`}>
          <FileUploaderProvider maxFilesCount={5}>
            <DocumentDetailsPageContainer />
          </FileUploaderProvider>
        </Route>
      </Switch>
    </DocumentsPageAccordionProvider>
  );
}
